<template>
  <div id="estop" class="maincont">
    <h5 class="content">ESアカウント HOME</h5>
  </div>
</template>

<script>
import Store from "../../store";
export default {
  name: "esTop",
  mounted: function() {
    console.log("mounted");

    // アカウントデータ取得
    this.$axios
      .get(`/srv/api/account/${Store.state.childID}`, {
        withCredentials: true
      })
      .then(response => {
        console.log(response.data);
        Store.dispatch("setChildInfo", response.data);
        this.measure_instrument = Store.state.childInfo.power_info['measure_instrument'];
      })
      .catch(error => {
        console.log(error);
      });
  }
}
</script>

<style scoped>
  .content{
    margin-left: 30px;
    margin-bottom: 300px;
    font-size: large;
    font-weight: bold;
  }
</style>
